
import { ElectricalAspectMetadataBase } from './electrical-aspect.metadata.base';


export class ElectricalAspectMetadata extends ElectricalAspectMetadataBase {
  constructor() {
    super();
  }
}

export const ELECTRICAL_ASPECT_METADATA: ElectricalAspectMetadata = new ElectricalAspectMetadata();


